// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ServiceEvents_carousel__A4729"};